export default __webpack_public_path__ + "static/media/EventMore.71443a2d.jpg";